module.exports = __webpack_public_path__ + "static/media/T7-GitHub.9e6da77b.svg";